import { useEffect } from 'react';
import { useSettings } from 'src/contexts/settings-context';

import i18n from '../i18n';

export const useUpdateLanguage = () => {
  const { settings } = useSettings();

  useEffect(() => {
    if (settings.language === i18n.language) return;
    i18n.changeLanguage(settings.language);
  }, [settings]);
};
